/**
 * Unit helpers. Canonical storage is feet (float). These convert for display
 * and snap values to the grid.
 */

/** Round a feet value to the nearest snap increment (also in feet). */
export function snap(value: number, increment: number): number {
  if (increment <= 0) return value
  return Math.round(value / increment) * increment
}

export function snapPoint(p: { x: number; y: number }, increment: number) {
  return { x: snap(p.x, increment), y: snap(p.y, increment) }
}

/** Format feet as a human ft+in string, e.g. 10.5 -> 10' 6". */
export function formatFeetInches(feet: number): string {
  const sign = feet < 0 ? '-' : ''
  const abs = Math.abs(feet)
  const wholeFeet = Math.floor(abs)
  const inches = Math.round((abs - wholeFeet) * 12)
  if (inches === 12) return `${sign}${wholeFeet + 1}'`
  if (inches === 0) return `${sign}${wholeFeet}'`
  return `${sign}${wholeFeet}' ${inches}"`
}

/** Compact decimal-feet label, e.g. 10.5 -> 10.5 ft. */
export function formatFeet(feet: number, digits = 1): string {
  return `${feet.toFixed(digits)} ft`
}

export const FEET_PER_INCH = 1 / 12
export const inches = (n: number) => n * FEET_PER_INCH
